/** Pesan disamakan dgn string error persis dari superoti-warehouse-server (internal/domain/auth/service.go). */
export const PIN_LOGIN_COPY = {
  pinWrong: 'PIN salah. Coba lagi atau hubungi Admin HO jika lupa PIN.',
  loginFailed: 'Login gagal. Coba lagi.',
  deviceDisabled: 'Perangkat dinonaktifkan. Hubungi Admin HO.',
} as const

export function isDeviceRevokedError(message: string): boolean {
  const lower = message.toLowerCase()
  return lower.includes('unbind') || lower.includes('kode aktivasi baru')
}

export function formatPinLoginError(message: string): string {
  if (message === 'PIN salah') return PIN_LOGIN_COPY.pinWrong
  if (message === 'perangkat dinonaktifkan') return PIN_LOGIN_COPY.deviceDisabled
  return message
}
